import { useSearchParams } from 'react-router-dom';
import { EnhancedRegisterForm } from '../components/auth/RegisterForm';

export default function RegisterPage() {
  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get('ref') || '';

  return (
    <div className="min-h-screen bg-dark-900 flex items-center justify-center px-4">
      <EnhancedRegisterForm initialReferralCode={referralCode} />
    </div>
  );
}
